// import React, { useEffect, useState } from "react";
// import {
//     Container,
//     Table,
//     Spinner,
//     Alert,
//     Button,
//     Modal,
//     ListGroup,
//     Toast,
//     ToastContainer
// } from "react-bootstrap";
// import axios from "axios";

// const AdminServiceRequests = () => {
//     const [serviceRequests, setServiceRequests] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedRequest, setSelectedRequest] = useState(null);
//     const [showVideoModal, setShowVideoModal] = useState(false);
//     const [currentVideo, setCurrentVideo] = useState("");
//     const [technicians, setTechnicians] = useState([]);
//     const [loadingTechnicians, setLoadingTechnicians] = useState(false);
//     const [showTechniciansModal, setShowTechniciansModal] = useState(false);
//     const [showToast, setShowToast] = useState(false);
//     const [toastMessage, setToastMessage] = useState("");
//     const [assigning, setAssigning] = useState(false);

//     useEffect(() => {
//         const fetchServiceRequests = async () => {
//             try {
//                 const response = await axios.get("https://madhusewingmachines.com/api/service-requests");
//                 setServiceRequests(response.data.data || []);
//             } catch (err) {
//                 setError("Failed to fetch service requests.");
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchServiceRequests();
//         const interval = setInterval(fetchServiceRequests, 10000);
//         return () => clearInterval(interval);
//     }, []);

//     const fetchTechnicians = async () => {
//         setLoadingTechnicians(true);
//         try {
//             const response = await axios.get("https://madhusewingmachines.com/api/technicians");
//             // Ensure we always set an array, even if response.data is undefined
//             setTechnicians(response.data?.data || response.data || []);
//         } catch (err) {
//             console.error("Failed to fetch technicians:", err);
//             setTechnicians([]); // Set empty array on error
//         } finally {
//             setLoadingTechnicians(false);
//         }
//     };

//     const handleShowTechniciansModal = async (request) => {
//         setSelectedRequest(request);
//         console.log("response requesttttttttttttttttttttttt", request)
//         console.log("selectedRequest", selectedRequest)
//         await fetchTechnicians();
//         setShowTechniciansModal(true);
//     };

//     const handleAssignTechnician = async (technicianId) => {
//         if (!selectedRequest || assigning) return;

//         setAssigning(true);
//         try {
//             const response = await axios.put(
//                 `https://madhusewingmachines.com/api/technicians/service-requests/${selectedRequest._id}/assign`,
//                 {
//                     technicianId,
//                     serviceRequest: selectedRequest._id,
//                     subService: {
//                         "name": "Sewing Machine"
//                     },
//                     user: {
//                         "name": selectedRequest.firstName,
//                         "email": "",
//                         "phone": selectedRequest.phoneNumber
//                     },
//                     status: "upcoming"
//                 },

//                 {
//                     headers: {
//                         'Content-Type': 'application/json'
//                     }
//                 }
//             );
//             console.log("assigning response", response)
//             setServiceRequests(prevRequests =>
//                 prevRequests.map(request =>
//                     request._id === selectedRequest
//                         ? {
//                             ...request,
//                             status: "Assigned",
//                             technician: response.data.technician
//                         }
//                         : request
//                 )
//             );

//             setShowTechniciansModal(false);
//             setToastMessage("Technician assigned successfully!");
//             setShowToast(true);
//         } catch (error) {
//             console.error("Error assigning technician:", error);
//             setToastMessage(
//                 error.response?.data?.message ||
//                 "Failed to assign technician"
//             );
//             setShowToast(true);
//         } finally {
//             setAssigning(false);
//         }
//     };

//     const handleImageError = (e) => {
//         e.target.style.objectFit = "cover";
//     };

//     const handleShowVideo = (videoPath) => {
//         setCurrentVideo(`https://madhusewingmachines.com/uploads/${videoPath}`);
//         setShowVideoModal(true);
//     };

//     const [technician, setTechnician] = useState({});

//     const getTechnicianById = async () => {
//         console.log("selectedRequest", selectedRequest.technician)
//         try {
//             const res = await axios.get(`https://madhusewingmachines.com/api/technicians/${selectedRequest.technician}`);
//             console.log("tecnician...............",res)
//         } catch (error) {
//             console.log(error)
//         }
//     }

//     useEffect(() => {
//         getTechnicianById()
//     }, [assigning,selectedRequest]);

//     return (
//         <Container className="py-4">
//             <h2 className="text-center mb-4">Service Requests</h2>

//             {loading ? (
//                 <div className="text-center">
//                     <Spinner animation="border" variant="primary" />
//                 </div>
//             ) : error ? (
//                 <Alert variant="danger">{error}</Alert>
//             ) : serviceRequests.length === 0 ? (
//                 <Alert variant="info">No service requests available.</Alert>
//             ) : (
//                 <Table striped bordered hover responsive>
//                     <thead>
//                         <tr>
//                             <th>#</th>
//                             <th>Customer Name</th>
//                             <th>Address</th>
//                             <th>City</th>
//                             <th>Phone</th>
//                             <th>Brand</th>
//                             <th>Model</th>
//                             <th>Image</th>
//                             <th>Video</th>
//                             <th>Status</th>
//                             <th>Assigned To</th>
//                             <th>Actions</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {serviceRequests.map((request, index) => (
//                             <tr key={request._id}>
//                                 <td>{index + 1}</td>
//                                 <td>{request.firstName} {request.lastName}</td>
//                                 <td>{request.address}</td>
//                                 <td>{request.city}</td>
//                                 <td>{request.phoneNumber}</td>
//                                 <td>{request.brand}</td>
//                                 <td>{request.model}</td>
//                                 <td>
//                                     {request.image ? (
//                                         <img
//                                             src={`https://madhusewingmachines.com/uploads/${request.image}`}
//                                             style={{
//                                                 width: "80px",
//                                                 height: "80px",
//                                                 objectFit: "contain"
//                                             }}
//                                             alt="Service Request"
//                                             onError={handleImageError}
//                                         />
//                                     ) : (
//                                         <img
//                                             src="https://via.placeholder.com/80x80?text=No+Image"
//                                             style={{
//                                                 width: "80px",
//                                                 height: "80px",
//                                                 objectFit: "cover"
//                                             }}
//                                             alt="No Image"
//                                         />
//                                     )}
//                                 </td>
//                                 <td>
//                                     {request.video ? (
//                                         <Button
//                                             variant="info"
//                                             size="sm"
//                                             onClick={() => handleShowVideo(request.video)}
//                                         >
//                                             View Video
//                                         </Button>
//                                     ) : (
//                                         <span>No Video</span>
//                                     )}
//                                 </td>
//                                 <td>{request.status || "Pending"}</td>
//                                 <td>
//                                     {/* {request.technician ?
//                                         `${request.technician.name} (${request.technician.phone})` :
//                                         "Not assigned"} */}
//                                     {request.technician}
//                                 </td>
//                                 <td>
//                                     {request.status !== "Assigned" && request.status !== "Rejected" && (
//                                         <Button
//                                             variant="primary"
//                                             size="sm"
//                                             onClick={() => handleShowTechniciansModal(request)}
//                                             className="me-2 mb-2"
//                                         >
//                                             Assign Technician
//                                         </Button>
//                                     )}
//                                 </td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </Table>
//             )}

//             {/* Technicians Selection Modal */}
//             <Modal
//                 show={showTechniciansModal}
//                 onHide={() => setShowTechniciansModal(false)}
//                 size="lg"
//                 centered
//             >
//                 <Modal.Header closeButton>
//                     <Modal.Title>Select a Technician</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     {loadingTechnicians ? (
//                         <div className="text-center">
//                             <Spinner animation="border" variant="primary" />
//                         </div>
//                     ) : technicians.length === 0 ? (
//                         <Alert variant="info">No technicians available.</Alert>
//                     ) : (
//                         <ListGroup>
//                             {technicians.map(technician => (
//                                 <ListGroup.Item
//                                     key={technician._id}
//                                     action
//                                     onClick={() => !assigning && handleAssignTechnician(technician._id)}
//                                     className="d-flex justify-content-between align-items-center"
//                                     disabled={assigning}
//                                 >
//                                     <div>
//                                         <strong>{technician.name}</strong>
//                                         <div className="text-muted small">
//                                             {technician.email} | {technician.phone}
//                                         </div>
//                                     </div>
//                                     <Button
//                                         size="sm"
//                                         variant="outline-primary"
//                                         disabled={assigning}
//                                     >
//                                         {assigning ? 'Assigning...' : 'Assign'}
//                                     </Button>
//                                 </ListGroup.Item>
//                             ))}
//                         </ListGroup>
//                     )}
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button
//                         variant="secondary"
//                         onClick={() => setShowTechniciansModal(false)}
//                         disabled={assigning}
//                     >
//                         Cancel
//                     </Button>
//                 </Modal.Footer>
//             </Modal>

//             {/* Video Modal */}
//             <Modal
//                 show={showVideoModal}
//                 onHide={() => setShowVideoModal(false)}
//                 size="lg"
//                 centered
//             >
//                 <Modal.Header closeButton>
//                     <Modal.Title>Service Request Video</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body className="text-center">
//                     {currentVideo && (
//                         <video controls width="100%">
//                             <source src={currentVideo} type="video/mp4" />
//                             Your browser does not support the video tag.
//                         </video>
//                     )}
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button variant="secondary" onClick={() => setShowVideoModal(false)}>
//                         Close
//                     </Button>
//                 </Modal.Footer>
//             </Modal>

//             {/* Toast Notification */}
//             <ToastContainer position="top-end" className="p-3">
//                 <Toast
//                     show={showToast}
//                     onClose={() => setShowToast(false)}
//                     delay={3000}
//                     autohide
//                     bg="success"
//                 >
//                     <Toast.Header>
//                         <strong className="me-auto">Notification</strong>
//                     </Toast.Header>
//                     <Toast.Body className="text-white">{toastMessage}</Toast.Body>
//                 </Toast>
//             </ToastContainer>
//         </Container>
//     );
// };

// export default AdminServiceRequests;
 
 
import React, { useEffect, useState } from "react";
import {
    Container,
    Table,
    Spinner,
    Alert,
    Button,
    Modal,
    ListGroup,
    Toast,
    ToastContainer,
    Badge
} from "react-bootstrap";
import axios from "axios";

const AdminServiceRequests = () => {
    const [serviceRequests, setServiceRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showVideoModal, setShowVideoModal] = useState(false);
    const [currentVideo, setCurrentVideo] = useState("");
    const [technicians, setTechnicians] = useState([]);
    const [loadingTechnicians, setLoadingTechnicians] = useState(false);
    const [showTechniciansModal, setShowTechniciansModal] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [assigning, setAssigning] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [technicianDetails, setTechnicianDetails] = useState({});
    
    // Location-related state management
    const [technicianLocations, setTechnicianLocations] = useState({});
    const [locationLoading, setLocationLoading] = useState({});
    const [jobStatuses, setJobStatuses] = useState({});
    
    // Additional state for better job status management
    const [statusLoading, setStatusLoading] = useState({});
    const [lastStatusUpdate, setLastStatusUpdate] = useState({});
    const [showMapModal, setShowMapModal] = useState(false);
    const [selectedTechnicianLocation, setSelectedTechnicianLocation] = useState(null);
    
    // Error tracking and caching to prevent excessive API calls
    const [technicianErrors, setTechnicianErrors] = useState({});
    const [lastFetchAttempt, setLastFetchAttempt] = useState({});
    const [failedTechnicians, setFailedTechnicians] = useState(new Set());

    // Optimized function to fetch individual technician location with error handling and caching
    const fetchTechnicianLocation = async (technicianId) => {
        // Skip if technician is known to be permanently failed (deleted/invalid)
        if (failedTechnicians.has(technicianId)) {
            console.log(`Skipping fetch for known failed technician: ${technicianId}`);
            return null;
        }
        // Implement exponential backoff for failed requests
        const lastAttempt = lastFetchAttempt[technicianId];
        const now = Date.now();
        const backoffTime = technicianErrors[technicianId] ? 
            Math.min(30000 * Math.pow(2, (technicianErrors[technicianId] || 0)), 300000) : // Max 5 minutes
            0;

        if (lastAttempt && (now - lastAttempt) < backoffTime) {
            console.log(`Skipping fetch for ${technicianId} due to backoff (${backoffTime}ms remaining)`);
            return null;
        }

        // Set loading state
        setLocationLoading(prev => ({ ...prev, [technicianId]: true }));
        setLastFetchAttempt(prev => ({ ...prev, [technicianId]: now }));

        try {
            const response = await axios.get(`https://madhusewingmachines.com/api/technicians/${technicianId}/location`);
            
            if (response.data.success && response.data.data.currentLocation) {
                // Success - reset error count and update location
                setTechnicianErrors(prev => ({ ...prev, [technicianId]: 0 }));
                setTechnicianLocations(prev => ({
                    ...prev,
                    [technicianId]: {
                        ...response.data.data.currentLocation,
                        loading: false,
                        error: null
                    }
                }));
                return response.data.data.currentLocation;
            } else {
                // No location data available
                setTechnicianLocations(prev => ({
                    ...prev,
                    [technicianId]: {
                        loading: false,
                        error: null,
                        address: null
                    }
                }));
                return null;
            }
        } catch (error) {
            console.error(`Failed to fetch location for technician ${technicianId}:`, error);
            
            // Handle different error types
            if (error.response?.status === 404) {
                // Technician not found - mark as permanently failed
                setFailedTechnicians(prev => new Set([...prev, technicianId]));
                setTechnicianLocations(prev => ({
                    ...prev,
                    [technicianId]: {
                        loading: false,
                        error: 'Technician not found',
                        address: null
                    }
                }));
            } else {
                // Temporary error - increment error count for backoff
                setTechnicianErrors(prev => ({
                    ...prev,
                    [technicianId]: (prev[technicianId] || 0) + 1
                }));
                setTechnicianLocations(prev => ({
                    ...prev,
                    [technicianId]: {
                        loading: false,
                        error: 'Location unavailable',
                        address: null
                    }
                }));
            }
            return null;
        } finally {
            setLocationLoading(prev => ({ ...prev, [technicianId]: false }));
        }
    };

    // Batch location fetching function for all assigned technicians
    const fetchAllTechnicianLocations = async (serviceRequests) => {
        console.log('🔄 FETCHING ALL TECHNICIAN LOCATIONS FOR SERVICE REQUESTS');
        
        // Extract unique technician IDs from assigned service requests
        const assignedTechnicianIds = serviceRequests
            .filter(request => request.technician && typeof request.technician === 'string')
            .map(request => request.technician)
            .filter((id, index, array) => array.indexOf(id) === index); // Remove duplicates

        console.log('👥 FOUND ASSIGNED TECHNICIANS:', assignedTechnicianIds);

        if (assignedTechnicianIds.length === 0) {
            console.log('ℹ️ NO ASSIGNED TECHNICIANS FOUND - SKIPPING LOCATION FETCH');
            return;
        }

        // Fetch locations for all assigned technicians concurrently
        const locationPromises = assignedTechnicianIds.map(async (technicianId) => {
            try {
                const location = await fetchTechnicianLocation(technicianId);
                return { technicianId, location, success: true };
            } catch (error) {
                console.error(`Failed to fetch location for technician ${technicianId}:`, error);
                return { technicianId, location: null, success: false, error };
            }
        });

        try {
            const results = await Promise.allSettled(locationPromises);
            
            let successCount = 0;
            let failureCount = 0;
            
            results.forEach((result, index) => {
                const technicianId = assignedTechnicianIds[index];
                
                if (result.status === 'fulfilled') {
                    const { success } = result.value;
                    if (success) {
                        successCount++;
                        console.log(`✅ LOCATION FETCHED FOR TECHNICIAN: ${technicianId}`);
                    } else {
                        failureCount++;
                        console.log(`❌ LOCATION FETCH FAILED FOR TECHNICIAN: ${technicianId}`);
                    }
                } else {
                    failureCount++;
                    console.error(`❌ PROMISE REJECTED FOR TECHNICIAN ${technicianId}:`, result.reason);
                }
            });

            console.log(`📊 BATCH LOCATION FETCH COMPLETE: ${successCount} success, ${failureCount} failures`);
            
            // Update last batch fetch timestamp for optimization
            setLastFetchAttempt(prev => ({
                ...prev,
                '_batch_fetch': Date.now()
            }));

        } catch (error) {
            console.error('❌ BATCH LOCATION FETCH ERROR:', error);
        }
    };

    useEffect(() => {
        const fetchServiceRequests = async () => {
            try {
                const response = await axios.get("https://madhusewingmachines.com/api/service-requests");
                const requests = response.data.data || [];
                setServiceRequests(requests);

                // Pre-fetch technician details for assigned requests
                const assignedRequests = requests.filter(req => req.technician && typeof req.technician === 'string');
                await fetchAllTechnicianDetails(assignedRequests);
            } catch (err) {
                setError("Failed to fetch service requests.");
            } finally {
                setLoading(false);
            }
        };

        const fetchAllTechnicianDetails = async (requests) => {
            const details = {};
            const locations = {};
            const jobStatuses = {};
            
            // Create a map to track job status by technician-serviceRequest combination
            const statusMap = {};
            
            for (const request of requests) {
                if (request.technician && typeof request.technician === 'string') {
                    const statusKey = `${request.technician}-${request._id}`;
                    
                    // Skip if we know this technician is permanently failed
                    if (failedTechnicians.has(request.technician)) {
                        details[request.technician] = { 
                            name: "Technician Not Found", 
                            phone: "N/A",
                            _id: request.technician,
                            error: true,
                            errorType: 'not_found'
                        };
                        statusMap[statusKey] = 'error';
                        jobStatuses[request.technician] = 'error';
                        locations[request.technician] = {
                            loading: false,
                            error: 'Technician not available',
                            address: null
                        };
                        continue;
                    }

                    try {
                        // Fetch technician basic details only if not already cached or failed recently
                        if (!technicianDetails[request.technician] || !technicianDetails[request.technician].error) {
                            const response = await axios.get(`https://madhusewingmachines.com/api/technicians/${request.technician}`);
                            details[request.technician] = response.data.data || response.data;
                        } else {
                            // Use cached details
                            details[request.technician] = technicianDetails[request.technician];
                        }
                        
                        // Fetch job status for this specific technician and service request
                        try {
                            const jobsResponse = await axios.get(`https://madhusewingmachines.com/api/jobs/technician/${request.technician}`);
                            const jobs = jobsResponse.data.data || [];
                            
                            // Find the job that matches this service request
                            const relatedJob = jobs.find(job => 
                                job.serviceRequest && 
                                (job.serviceRequest._id === request._id || job.serviceRequest === request._id)
                            );
                            
                            if (relatedJob) {
                                const jobStatus = relatedJob.status;
                                statusMap[statusKey] = jobStatus;
                                jobStatuses[request.technician] = jobStatus; // Keep for backward compatibility
                                
                                console.log(`No job found for technician ${request.technician}, service request ${request._id} - setting status to upcoming`);
                            }
                        } catch (jobError) {
                            console.error(`Failed to fetch job status for technician ${request.technician}:`, jobError);
                            statusMap[statusKey] = 'error';
                            jobStatuses[request.technician] = 'error';
                            locations[request.technician] = {
                                loading: false,
                                error: 'Job status unknown',
                                address: null
                            };
                        }
                    } catch (error) {
                        console.error(`Failed to fetch technician ${request.technician}:`, error);
                        // Handle different types of errors gracefully
                        if (error.response?.status === 404) {
                            // Technician not found (deleted or invalid ID) - mark as permanently failed
                            setFailedTechnicians(prev => new Set([...prev, request.technician]));
                            details[request.technician] = { 
                                name: "Technician Not Found", 
                                phone: "N/A",
                                _id: request.technician,
                                error: true,
                                errorType: 'not_found'
                            };
                        } else if (error.response?.status === 500 || error.response?.status === 400) {
                            // Server error or invalid ID format
                            details[request.technician] = { 
                                name: "Invalid Technician", 
                                phone: "N/A",
                                _id: request.technician,
                                error: true,
                                errorType: 'server_error'
                            };
                        } else {
                            // Network or other errors
                            details[request.technician] = { 
                                name: "Unknown Technician", 
                                phone: "N/A",
                                _id: request.technician,
                                error: true,
                                errorType: 'unknown'
                            };
                        }
                        
                        // Set error status for all error types
                        statusMap[statusKey] = 'error';
                        jobStatuses[request.technician] = 'error';
                        locations[request.technician] = {
                            loading: false,
                            error: 'Technician not available',
                            address: null
                        };
                    }
                }
            }
            
            setTechnicianDetails(details);
            setTechnicianLocations(locations);
            setJobStatuses(statusMap); // Use the detailed status map
            
            // After fetching technician details, batch fetch all locations
            await fetchAllTechnicianLocations(requests);
        };

        fetchServiceRequests();
        
        // Set up intervals - less frequent full refresh only
        const fullRefreshInterval = setInterval(fetchServiceRequests, 30000); // Every 30 seconds
        
        return () => {
            clearInterval(fullRefreshInterval);
        };
    }, []);

    const fetchTechnicians = async () => {
        setLoadingTechnicians(true);
        try {
            const response = await axios.get("https://madhusewingmachines.com/api/technicians");
            setTechnicians(response.data?.data || response.data || []);
        } catch (err) {
            console.error("Failed to fetch technicians:", err);
            setTechnicians([]);
        } finally {
            setLoadingTechnicians(false);
        }
    };
    // Helper function to fetch job status for a specific technician and service request
    const fetchJobStatus = async (technicianId, serviceRequestId) => {
        const statusKey = `${technicianId}-${serviceRequestId}`;
        
        try {
            setStatusLoading(prev => ({ ...prev, [statusKey]: true }));
            
            const response = await axios.get(`https://madhusewingmachines.com/api/jobs/technician/${technicianId}`);
            const jobs = response.data.data || [];
            
            const relatedJob = jobs.find(job => 
                job.serviceRequest && 
                (job.serviceRequest._id === serviceRequestId || job.serviceRequest === serviceRequestId)
            );
            
            const status = relatedJob ? relatedJob.status : 'upcoming';
            
            setJobStatuses(prev => ({
                ...prev,
                [statusKey]: status
            }));
            
            setLastStatusUpdate(prev => ({
                ...prev,
                [statusKey]: new Date()
            }));
            
            // If job was just accepted, immediately try to fetch location
            if (status === 'accepted' && relatedJob) {
                setTimeout(() => {
                    fetchTechnicianLocation(technicianId);
                }, 2000); // Wait 2 seconds for location to be updated on server
            }
            
            return status;
        } catch (error) {
            console.error(`Failed to fetch job status for ${statusKey}:`, error);
            setJobStatuses(prev => ({
                ...prev,
                [statusKey]: 'error'
            }));
            return 'error';
        } finally {
            setStatusLoading(prev => ({ ...prev, [statusKey]: false }));
        }
    };

    // Helper function to get job status with caching
    const getJobStatus = (technicianId, serviceRequestId) => {
        const statusKey = `${technicianId}-${serviceRequestId}`;
        return jobStatuses[statusKey] || 'unknown';
    };

    // Helper function to check if status is loading
    const isStatusLoading = (technicianId, serviceRequestId) => {
        const statusKey = `${technicianId}-${serviceRequestId}`;
        return statusLoading[statusKey] || false;
    };

    // Helper function to refresh job status for a specific request
    const refreshJobStatus = async (technicianId, serviceRequestId) => {
        return await fetchJobStatus(technicianId, serviceRequestId);
    };

    const handleShowTechniciansModal = async (request) => {
        setSelectedRequest(request);
        await fetchTechnicians();
        setShowTechniciansModal(true);
    };

    const handleAssignTechnician = async (technicianId) => {
        if (!selectedRequest || assigning) return;  
        console.log('selectedRequest', selectedRequest)

        setAssigning(true);
        try {
            const response = await axios.put(
                `https://madhusewingmachines.com/api/technicians/service-requests/${selectedRequest._id}/assign`,
                {
                    technicianId,
                    serviceRequest: selectedRequest._id,
                    user: {
                        name: selectedRequest?.firstName || '',
                        address: selectedRequest?.address || '',
                        phone: selectedRequest?.phoneNumber || ''
                    },
                    status: "upcoming"
                },
                {
                    headers: { 'Content-Type': 'application/json' }
                }
            );

            const technician = response.data.technician || response.data.data;
            setTechnicianDetails(prev => ({
                ...prev,
                [technicianId]: technician
            }));

            // Initialize job status as upcoming for the new assignment
            const statusKey = `${technicianId}-${selectedRequest._id}`;
            setJobStatuses(prev => ({
                ...prev,
                [statusKey]: 'upcoming'
            }));

            setServiceRequests(prevRequests =>
                prevRequests.map(request =>
                    request._id === selectedRequest._id
                        ? {
                            ...request,
                            status: "Assigned",
                            technician: technicianId
                        }
                        : request
                )
            );

            setShowTechniciansModal(false);
            setToastMessage("Technician assigned successfully!");
            setShowToast(true);

            // Immediately refresh the job status to get the latest state
            setTimeout(() => {
                refreshJobStatus(technicianId, selectedRequest._id);
            }, 1000);

        } catch (error) {
            console.error("Error assigning technician:", error);
            setToastMessage(
                error.response?.data?.message || "Failed to assign technician"
            );
            setShowToast(true);
        } finally {
            setAssigning(false);
        }
    };
    const getTechnicianDisplay = (technician) => {
        if (!technician) return "Not assigned";

        if (typeof technician === 'object') {
            return `${technician.name} (${technician.phone || 'No phone'})`;
        }

        if (technicianDetails[technician]) {
            const tech = technicianDetails[technician];
            if (tech.error) {
                const errorMessages = {
                    'not_found': 'Technician Deleted',
                    'server_error': 'Invalid Technician ID',
                    'unknown': 'Error Loading Technician'
                };
                const errorMsg = errorMessages[tech.errorType] || 'Error Loading Details';
                return (
                    <span className="text-danger">
                        {tech.name} <small>({errorMsg})</small>
                    </span>
                );
            }
            return `${tech.name} (${tech.phone || 'No phone'})`;
        }

        return "Loading...";
    };
    const handleShowMap = (technician, request) => {
        console.log('👁️ EYE BUTTON CLICKED - SHOWING MAP MODAL:', {
            technician,
            requestId: request._id,
            customerName: `${request.firstName} ${request.lastName}`
        });
        
        const location = technicianLocations[technician];
        const technicianDetail = technicianDetails[technician];
        
        console.log('📍 LOCATION DATA FOR MAP:', {
            hasLocation: !!location,
            locationData: location,
            technicianDetail: technicianDetail
        });
        
        if (location && location.latitude && location.longitude) {
            const locationData = {
                technician: technicianDetail || { name: 'Unknown Technician', phone: 'N/A' },
                location: location,
                request: request
            };
            
            console.log('✅ SHOWING MAP MODAL WITH LOCATION DATA:', locationData);
            setSelectedTechnicianLocation(locationData);
            setShowMapModal(true);
        } else {
            console.log('⚠️ NO LOCATION DATA - SHOWING MODAL WITH ERROR MESSAGE');
            // Show modal anyway with error message
            setSelectedTechnicianLocation({
                technician: technicianDetail || { name: 'Unknown Technician', phone: 'N/A' },
                location: null,
                request: request
            });
            setShowMapModal(true);
        }
    };

    const getLocationDisplay = (technician, request) => {
        console.log('🗺️ GETTING LOCATION DISPLAY:', {
            technician,
            requestId: request._id,
            requestStatus: request.status,
            hasTechnician: !!request.technician
        });
        
        if (!technician || !request.technician) {
            console.log('❌ NO TECHNICIAN ASSIGNED - SHOWING DASH');
            return <span className="text-muted">-</span>;
        }

        // Use the detailed status map with technician-serviceRequest combination
        const statusKey = `${technician}-${request._id}`;
        const jobStatus = jobStatuses[statusKey];
        
        console.log('📊 JOB STATUS CHECK:', {
            statusKey,
            jobStatus,
            requestStatus: request.status,
            hasLocationData: !!technicianLocations[technician]
        });
        
        // Only show location if job is accepted by technician
        if (request.status === "Assigned" && jobStatus === "accepted" && technicianLocations[technician]) {
            const location = technicianLocations[technician];
            console.log('📍 SHOWING LOCATION FOR ACCEPTED JOB:', {
                technician,
                hasAddress: !!location.address,
                hasError: !!location.error,
                location
            });
            
            if (location.address && !location.error) {
                const locationText = location.address.length > 25 
                    ? `${location.address.substring(0, 25)}...` 
                    : location.address;
                
                // Check if location is stale (older than 1 hour)
                const isStale = location.lastUpdated && 
                    (new Date() - new Date(location.lastUpdated)) > 3600000;
                
                return (
                    <div>
                        <div className="d-flex align-items-center">
                            <span className="text-success small me-2" title={location.address}>
                                {locationText}
                            </span>
                            <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => {
                                    console.log('👁️ EYE BUTTON CLICKED FOR LOCATION:', {
                                        technician,
                                        requestId: request._id,
                                        location
                                    });
                                    handleShowMap(technician, request);
                                }}
                                title="View location on map"
                                style={{ padding: '2px 6px', fontSize: '12px' }}
                            >
                                👁️
                            </Button>
                        </div>
                        {location.lastUpdated && (
                            <div className="text-muted small">
                                {getTimeAgo(location.lastUpdated)}
                                {isStale && <span className="text-warning"> (outdated)</span>}
                            </div>
                        )}
                    </div>
                );
            } else if (location.error) {
                console.log('⚠️ LOCATION ERROR - SHOWING UNAVAILABLE MESSAGE');
                return <span className="text-muted small">📍 Location unavailable</span>;
            }
        }

        // Show status for assigned requests
        if (request.status === "Assigned") {
            console.log('📋 SHOWING JOB STATUS FOR ASSIGNED REQUEST:', jobStatus);
            switch (jobStatus) {
                case "upcoming":
                    return <span className="text-warning small">⏳ Waiting for acceptance</span>;
                case "accepted":
                    // Show eye button instead of text when location tracking is in progress
                    return (
                        <div className="d-flex align-items-center">
                            <span className="text-info small me-2">📍 Tracking location</span>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                disabled
                                title="Location not yet available"
                                style={{ padding: '2px 6px', fontSize: '12px' }}
                            >
                                👁️
                            </Button>
                        </div>
                    );
                case "completed":
                    return <span className="text-success small">✅ Job completed</span>;
                case "rejected":
                    return <span className="text-danger small">❌ Job rejected</span>;
                case "error":
                    return <span className="text-muted small">⚠️ Status unknown</span>;
                default:
                    return <span className="text-muted small">⏳ Checking status...</span>;
            }
        }

        console.log('❓ DEFAULT CASE - SHOWING DASH');
        return <span className="text-muted">-</span>;
    };

    // Utility function to format time ago
    const getTimeAgo = (timestamp) => {
        const now = new Date();
        const past = new Date(timestamp);
        const diffMs = now - past;
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMins / 60);
        const diffDays = Math.floor(diffHours / 24);

        if (diffMins < 1) return "Just now";
        if (diffMins < 60) return `${diffMins} min ago`;
        if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
        return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
    };

    const handleImageError = (e) => {
        e.target.style.objectFit = "cover";
    };

    const handleShowVideo = (videoPath) => {
        setCurrentVideo(`https://madhusewingmachines.com/uploads/${videoPath}`);
        setShowVideoModal(true);
    };

    return (
        <Container className="py-4">
            <h2 className="text-center mb-4">Service Requests</h2>
            
            {/* Debug Panel - Remove this after testing */}
            {/* <div className="mb-3 p-2 bg-light rounded">
                <small className="text-muted">
                    Debug: Test location for technician 690e1feca081dc5a49c07dfc
                    <Button
                        size="sm"
                        variant="outline-info"
                        className="ms-2"
                        onClick={async () => {
                            console.log('Testing location fetch...');
                            const result = await fetchTechnicianLocation('690e1feca081dc5a49c07dfc');
                            console.log('Location result:', result);
                        }}
                    >
                        Test Location
                    </Button>
                </small>
            </div> */}

            {loading ? (
                <div className="text-center">
                    <Spinner animation="border" variant="primary" />
                </div>
            ) : error ? (
                <Alert variant="danger">{error}</Alert>
            ) : serviceRequests.length === 0 ? (
                <Alert variant="info">No service requests available.</Alert>
            ) : (
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Customer Name</th>
                            <th>Address</th>
                            <th>City</th>
                            <th>Phone</th>
                            <th>Brand</th>
                            <th>Model</th>
                            <th>Image</th>
                            <th>Video</th>
                            <th>Status</th>
                            <th>Assigned To</th>
                            <th>Location</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {serviceRequests.map((request, index) => (
                            <tr key={request._id}>
                                <td>{index + 1}</td>
                                <td>{request.firstName} {request.lastName}</td>
                                <td>{request.address}</td>
                                <td>{request.city}</td>
                                <td>{request.phoneNumber}</td>
                                <td>{request.brand}</td>
                                <td>{request.model}</td>
                                <td>
                                {request.image ? (
                                        <img
                                            src={`https://madhusewingmachines.com/uploads/${request.image}`}
                                            style={{
                                                width: "80px",
                                                height: "80px",
                                                objectFit: "contain"
                                            }}
                                            alt="Service Request"
                                            onError={handleImageError}
                                        />
                                    ) : (
                                        <img
                                            src="https://via.placeholder.com/80x80?text=No+Image"
                                            style={{
                                                width: "80px",
                                                height: "80px",
                                                objectFit: "cover"
                                            }}
                                            alt="No Image"
                                        />
                                    )}
                                </td>
                                <td>
                                    {request.video ? (
                                        <Button
                                            variant="info"
                                            size="sm"
                                            onClick={() => handleShowVideo(request.video)}
                                        >
                                            View Video
                                        </Button>
                                    ) : (
                                        <span>No Video</span>
                                    )}
                                </td>
                                <td>{request.status || "Pending"}</td>
                                <td>
                                    {getTechnicianDisplay(request.technician)}
                                </td>
                                <td>
                                    {getLocationDisplay(request.technician, request)}
                                    {/* Debug button to manually refresh location */}
                                    {request.status === "Assigned" && request.technician && (
                                        <div className="mt-1">
                                            <Button
                                                variant="outline-secondary"
                                                size="sm"
                                                onClick={async () => {
                                                    console.log(`Manual refresh for technician ${request.technician}`);
                                                    await fetchJobStatus(request.technician, request._id);
                                                    await fetchTechnicianLocation(request.technician);
                                                }}
                                                style={{ padding: '1px 4px', fontSize: '10px' }}
                                                title="Refresh status and location"
                                            >
                                                🔄
                                            </Button>
                                        </div>
                                    )}
                                </td>
                              <td>
  {request.status?.toLowerCase() === "completed" ? (
    <Badge bg="success">Completed</Badge>
  ) : request.status === "Assigned" ? (
    <Badge bg="info">Assigned</Badge>
  ) : request.status === "Rejected" ? (
    <Badge bg="danger">Rejected</Badge>
  ) : (
    <Button
      variant="primary"
      size="sm"
      onClick={() => handleShowTechniciansModal(request)}
      className="me-2 mb-2"
    >
      Assign Technician
    </Button>
  )}
</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}

            {/* Technicians Selection Modal */}
            <Modal
                show={showTechniciansModal}
                onHide={() => setShowTechniciansModal(false)}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Select a Technician</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loadingTechnicians ? (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : technicians.length === 0 ? (
                        <Alert variant="info">No technicians available.</Alert>
                    ) : (
                        <ListGroup>
                            {technicians.map(technician => (
                                <ListGroup.Item
                                    key={technician._id}
                                    action
                                    onClick={() => !assigning && handleAssignTechnician(technician._id)}
                                    className="d-flex justify-content-between align-items-center"
                                    disabled={assigning}
                                >
                                    <div>
                                        <strong>{technician.name}</strong>
                                        <div className="text-muted small">
                                            {technician.email} | {technician.phone}
                                        </div>
                                        <div className="text-muted small">
                                            Skills: {technician.skills?.join(', ') || 'Not specified'}
                                        </div>
                                    </div>
                                    <Button
                                        size="sm"
                                        variant="outline-primary"
                                        disabled={assigning}
                                    >
                                        {assigning ? 'Assigning...' : 'Assign'}
                                    </Button>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setShowTechniciansModal(false)}
                        disabled={assigning}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Map Modal */}
            <Modal
                show={showMapModal}
                onHide={() => setShowMapModal(false)}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Technician Location - {selectedTechnicianLocation?.technician?.name}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedTechnicianLocation && selectedTechnicianLocation.location ? (
                        <div>
                            <div className="mb-3">
                                <strong>Technician:</strong> {selectedTechnicianLocation.technician.name}
                            </div>
                            <div className="mb-3">
                                <strong>Phone:</strong> {selectedTechnicianLocation.technician.phone || 'Not available'}
                            </div>
                            <div className="mb-3">
                                <strong>Address:</strong> 
                                <div className="mt-1 p-2 bg-light rounded">
                                    {selectedTechnicianLocation.location.address || 'Address not available'}
                                </div>
                            </div>
                            <div className="mb-3">
                                <strong>Last Updated:</strong> 
                                <span className="ms-2 badge bg-info">
                                    {getTimeAgo(selectedTechnicianLocation.location.lastUpdated)}
                                </span>
                            </div>
                            <div className="mb-3">
                                <strong>Coordinates:</strong> 
                                <div className="mt-1">
                                    <code>
                                        Lat: {selectedTechnicianLocation.location.latitude}, 
                                        Lng: {selectedTechnicianLocation.location.longitude}
                                    </code>
                                </div>
                            </div>
                            
                            {/* Quick Map Actions */}
                            <div className="mb-3">
                                <strong>Map Actions:</strong>
                                <div className="d-grid gap-2 mt-2">
                                    <Button
                                        variant="primary"
                                        onClick={() => {
                                            const { latitude, longitude } = selectedTechnicianLocation.location;
                                            const url = `https://www.google.com/maps?q=${latitude},${longitude}`;
                                            window.open(url, '_blank');
                                        }}
                                    >
                                        📍 View on Google Maps
                                    </Button>
                                    <Button
                                        variant="outline-primary"
                                        onClick={() => {
                                            const { latitude, longitude } = selectedTechnicianLocation.location;
                                            const url = `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;
                                            window.open(url, '_blank');
                                        }}
                                    >
                                        🧭 Get Directions
                                    </Button>
                                </div>
                            </div>
                            
                            {/* Additional Actions */}
                            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => {
                                        const locationText = `Technician: ${selectedTechnicianLocation.technician.name}\nLocation: ${selectedTechnicianLocation.location.address}\nCoordinates: ${selectedTechnicianLocation.location.latitude}, ${selectedTechnicianLocation.location.longitude}\nLast Updated: ${getTimeAgo(selectedTechnicianLocation.location.lastUpdated)}`;
                                        navigator.clipboard.writeText(locationText);
                                        setToastMessage("Location details copied to clipboard!");
                                        setShowToast(true);
                                    }}
                                >
                                    📋 Copy Details
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <div className="text-center py-4">
                            <div className="mb-3">
                                <i className="fas fa-map-marker-alt fa-3x text-muted"></i>
                            </div>
                            <h5>Location Not Available</h5>
                            <p className="text-muted">
                                Location information is not available for this technician.
                            </p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowMapModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Video Modal */}
            <Modal
                show={showVideoModal}
                onHide={() => setShowVideoModal(false)}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Service Request Video</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {currentVideo && (
                        <video controls width="100%">
                            <source src={currentVideo} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowVideoModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Toast Notification */}
            <ToastContainer position="top-end" className="p-3">
                <Toast
                    show={showToast}
                    onClose={() => setShowToast(false)}
                    delay={3000}
                    autohide
                    bg="success"
                >
                    <Toast.Header>
                        <strong className="me-auto">Notification</strong>
                    </Toast.Header>
                    <Toast.Body className="text-white">{toastMessage}</Toast.Body>
                </Toast>
            </ToastContainer>
        </Container>
    );
};
export default AdminServiceRequests;